export default __webpack_public_path__ + "assets/sounds/src/sounds/alarm-sound.mp3";